// RoundCross.tsx
import React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";

const RoundCross = (props: SvgProps) => {
  return (
    <Svg width="20" height="20" fill="none">
      <Path
        fill="#CC293F"
        d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 18.182A8.181 8.181 0 1 1 18.182 10 8.193 8.193 0 0 1 10 18.182Z"
      />
      <Path
        fill="#CC293F"
        d="m12.568 6.144-2.571 2.57-2.571-2.57-1.285 1.285L8.71 10l-2.57 2.571 1.285 1.286 2.571-2.571 2.571 2.57 1.285-1.285-2.57-2.57 2.57-2.572-1.285-1.285Z"
      />
    </Svg>
  );
};

export default RoundCross;
